import { LOCALE } from "../../../constant";
import { dateToTimestamp } from "../../../utils/time/time";
import { Article } from "../Article/ArticlesTypes";
import { Reservation, IReservationDay } from "./ReservationsTypes";

const getDailyReservations = (
  reservations: Reservation[],
  startingDate: number,
  quota: number | undefined,
  quotaTotalMax: number | undefined,
  articles: Article[],
  numberOfReservations: string | undefined,
  coworkerHourLimit: string | undefined
): IReservationDay[] => {

  const dailyReservations: IReservationDay[] = [];
  const numberOfDayInaWeek = 5;
  if (!numberOfReservations) {
    numberOfReservations = "0"
  }
  if (!coworkerHourLimit) {
    coworkerHourLimit = "0"
  }

  //sort all reservations for each day of the week
  for (let index = 0; index < numberOfDayInaWeek; index++) {
    //Get the date of the day at 00h00
    const startingDateTimestamp = startingDate * 1000;
    const dayAtIndex: Date = new Date(startingDateTimestamp);
    dayAtIndex.setDate(dayAtIndex.getDate() + index);

    //Get the name of the day
    const wordDay: string = dayAtIndex.toLocaleDateString(LOCALE, { weekday: 'long' });
    const dayName: string = wordDay[0].toUpperCase() + wordDay.slice(1).toLowerCase()

    const dateNow = new Date();
    // Récupération du quota, soit du département soit de tous les départements
    const oneDayInMs = 24 * 60 * 60 * 1000;  // 1 jour en millisecondes
    const coworkerHourLimitTimestamp = Number.parseInt(coworkerHourLimit) * 60 * 60 * 1000;  // Heure limite en millisecondes
    const dailyQuota = (dateNow >= new Date(dayAtIndex.getTime() - oneDayInMs + coworkerHourLimitTimestamp))
        ? quotaTotalMax 
        : quota;
    //Filter articles
    let sortedArticles: Article[] = []

    if (articles) {
      const filteredArticles = articles.filter(article =>
        article.startDate - 28_800 <= dateToTimestamp(dayAtIndex) && article.endDate + 28_800 >= dateToTimestamp(dayAtIndex) && (article.categoryId !== 3 && article.categoryId !== 4)
      );
      sortedArticles = filteredArticles.sort((a, b) => a.startDate - b.startDate);
    }

    // Filter reservervation list
    const dailyreserved = reservations.filter(reservation => reservation.status === "reserved" && reservation.date >= dateToTimestamp(dayAtIndex) && reservation.date <= dateToTimestamp(dayAtIndex) + 28_800);

    // Filter waiting list
    const dailywaiting = reservations.filter(reservation => reservation.status === "waiting" && reservation.date >= dateToTimestamp(dayAtIndex) && reservation.date <= dateToTimestamp(dayAtIndex) + 28_800);

    //Create an Array for each Reservation of the week
    dailyReservations.push({
      date: dateToTimestamp(dayAtIndex),
      dayName: dayName,
      quota: dailyQuota,
      Reservations: dailyreserved,
      Articles: sortedArticles,
      WaitingList: dailywaiting
    })
  }

  return dailyReservations

};

export { getDailyReservations };


